// @ts-ignore
import * as React from 'react';
import TextInput, { Props as TextInputProps } from '@af-common/Common/_components/TextInput';
import Dimensions from '../../Utils/Dimensions';
import AwareComponent from '@af-common/Common/_components/AwareComponent';
import { Trans } from 'react-i18next';

export type Props = {
	moduleId?: string
	radius?: number
	documentWidth?: number
	documentHeight?: number
	onRadiusChange?: Function
} & TextInputProps

type State = {
	max: number
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class ModuleRadius extends AwareComponent<Props> {
	static defaultProps = {
		label: <T>Radius</T>
	}

	state = { max: 100 }

	componentDidUpdate(prevProps:Props, prevState:State){
		if(this.propChanged(prevProps, 'radius', 'documentWidth', 'documentHeight')){
			let max = Dimensions.getModuleMaxDimensions(this.props.radius, this.props.radius, this.props.documentWidth, this.props.documentHeight);
			let max_value = Math.round(max.width * Math.SQRT2 / 2);
			if(this.state.max !== max_value) this.setState({max: max_value});
			if(this.props.radius > max_value) this.onRadiusChange(this.props.radius, max_value);
		}
	}

	private onRadiusChange = (radius:number, max:number = this.state.max) => {
		radius = Math.min(max, radius);
		this.props.onRadiusChange(radius);
	}

	render = () => {
		const {moduleId, radius, documentWidth, documentHeight, onRadiusChange, ...props} = this.props;
		return <TextInput useUnits min={1} max={this.state.max} step={1} type="number" label={this.props.label} onChange={(value) => this.onRadiusChange(Number(value))} value={String(this.props.radius)} {...props}/>
	}
}